'use strict';

var buttonContainer = angular.module('saturn.button.container', []);

var ButtonContainerDirective = require('./ButtonContainerDirective');
var ButtonContainerController = require('./ButtonContainerController');

buttonContainer.controller('ButtonContainerController', [
  '$animate',
  '$q',
  '$scope',
  '$interval',
  ButtonContainerController
]);

buttonContainer.directive('sbButtonContainer', [
  ButtonContainerDirective
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/button/src/buttonContainer/index.js